import React from 'react';
import { connect } from 'react-redux';
import {
  collectedByPageRequest,
  changeDateCollectedBy,
  changeOutletCollectedBy,
  exportCollectedBy,
} from 'actions/reports/sales';
import NoDataDisplay from 'components/NoDataDisplay/NoDataDisplay';
import moment from 'moment';
import { formValueSelector } from 'redux-form';
import LoadingSpinner from 'components/LoadingSpinner';
import TableWithoutChild from 'components/TableReportSales/TableWithoutChild';
import { rupiahWithNegativeWithoutBracket } from 'utils/formatter';
import _ from 'lodash';
import * as clevertapReportsCollected from 'clevertap/reports/collected';
import { isFullSiteMode } from 'utils/fullSite';
import { getFormattedTime, getFormattedEndDate } from 'utils/hourFilter';
import ActionBar from '../ActionBar';
import styles from './CollectedBy.css';
import BodyFrame from '../BodyFrame';

class CollectedBy extends React.Component {
  componentDidMount() {
    this.props.dispatch(collectedByPageRequest());
  }

  render() {
    const { staffs, showLoadingSpinnerReport } = this.props.data.reports.staffs;
    let staffData = [];
    for (const key in staffs.staff_reports) {
      staffData.push(staffs.staff_reports[key]);
    }
    // dari server udah sorted by id harusnya
    // just to make sure
    staffData = staffData.sort((a, b) => {
      return a.staff_id - b.staff_id;
    });
    const [footBody, childBody] = this._formatDataForList(staffData, staffs);
    const footBodyResponsive = this._formatFootBody(_.cloneDeep(footBody));
    const childBodyResponsive = this._formatChildBody(_.cloneDeep(childBody));

    return (
      <div id="reports-sales-collected-by" className={`${styles.wrapper}`}>
        <ActionBar
          onChangeDate={this._onChangeDate}
          onChangeOutlet={this._onChangeOutlet}
          onExport={this._onClickExport}
        />
        <BodyFrame location={this.props.location}>
          <div className={`${styles.tableWrapper} visible-md visible-lg`}>
            <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
            {staffData.length > 0 && (
              <TableWithoutChild
                headerBody={[
                  'Name',
                  'Title',
                  'Number of Transactions',
                  'Total Collected',
                ]}
                childBody={childBody}
                footBody={footBody}
                tableClass="collected-by-table"
                // TODO fix this code. for reports sales, only collected by component produces wrong layout in full site mode
                headerBodyClassName={
                  !isFullSiteMode()
                    ? [
                        'header-name',
                        'header-titla',
                        'header-number-of-transaction',
                        'header-total-collected',
                      ]
                    : [
                        `header-name ${styles['col-full-site']}`,
                        `header-titla ${styles['col-full-site']}`,
                        `header-number-of-transaction ${
                          styles['col-full-site']
                        }`,
                        `header-total-collected ${styles['col-full-site']}`,
                      ]
                }
                childBodyClassName={
                  !isFullSiteMode()
                    ? [
                        'body-name',
                        'body-titla',
                        'body-number-of-transaction',
                        'body-total-collected',
                      ]
                    : [
                        `body-name ${styles['col-full-site']}`,
                        `body-titla ${styles['col-full-site']}`,
                        `body-number-of-transaction ${styles['col-full-site']}`,
                        `body-total-collected ${styles['col-full-site']}`,
                      ]
                }
                footBodyClassName={
                  !isFullSiteMode()
                    ? [
                        'foot-name',
                        'foot-titla',
                        'foot-number-of-transaction',
                        'foot-total-collected',
                      ]
                    : [
                        `foot-name ${styles['col-full-site']}`,
                        `foot-titla ${styles['col-full-site']}`,
                        `foot-number-of-transaction ${styles['col-full-site']}`,
                        `foot-total-collected ${styles['col-full-site']}`,
                      ]
                }
              />
            )}
            {!staffData.length && !showLoadingSpinnerReport && (
              <div className="no-data-display-container">
                <NoDataDisplay title="No Data to Display" />
              </div>
            )}
          </div>
          <div
            className={`${styles.tableWrapperResponsive} visible-xs visible-sm`}
          >
            <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
            {staffData.length > 0 && (
              <TableWithoutChild
                headerBody={[
                  'Name',
                  'Number of Transactions',
                  'Total Collected',
                ]}
                childBody={childBodyResponsive}
                footBody={footBodyResponsive}
                tableClass="collected-by-table-responsive"
                headerBodyClassName={[
                  'header-name',
                  'header-number-of-transaction',
                  'header-total-collected',
                ]}
                childBodyClassName={[
                  'body-name',
                  'body-number-of-transaction',
                  'body-total-collected',
                ]}
                footBodyClassName={[
                  'foot-name',
                  'foot-number-of-transaction',
                  'foot-total-collected',
                ]}
              />
            )}
            {!staffData.length && !showLoadingSpinnerReport && (
              <div className="no-data-display-container">
                <NoDataDisplay title="No Data to Display" />
              </div>
            )}
          </div>
        </BodyFrame>
      </div>
    );
  }

  _formatDataForList = (staffReports, staffs) => {
    const childBody = [];
    const footBody = {
      name: 'Total',
      title: null,
      total_transaction_count: staffs.total_transaction_count,
      total_transaction_amount: rupiahWithNegativeWithoutBracket(
        staffs.total_transaction_amount
      ),
    };
    if (staffReports) {
      staffReports.map(function(staffReport) {
        childBody.push({
          staff_name: staffReport.staff_name,
          staff_title: staffReport.staff_title,
          staff_transaction_count: staffReport.staff_transaction_count,
          staff_transaction_amount: rupiahWithNegativeWithoutBracket(
            staffReport.staff_transaction_amount
          ),
        });
      });
    }
    return [footBody, childBody];
  };

  _formatFootBody = footBody => {
    delete footBody.title;
    return footBody;
  };

  _formatChildBody = childBody => {
    const result = [];
    childBody.map(function(val) {
      delete val.staff_title;
      result.push(val);
    });
    return result;
  };

  _onChangeOutlet = outletIds => {
    const {
      date: { startDate, endDate, startHour, endHour, allDay },
    } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      changeOutletCollectedBy({
        outletIds,
        startDate: formattedStart,
        endDate: formattedEnd,
      })
    );
  };

  _onChangeDate = ({ startDate, endDate, startHour, endHour, allDay }) => {
    const { outlet: outletIds } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      changeDateCollectedBy(formattedStart, formattedEnd, outletIds)
    );
  };

  _onClickExport = () => {
    const {
      outlet,
      date: { startDate, endDate, startHour, endHour, allDay },
    } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const format = allDay ? 'DD-MM-YYYY' : 'DD-MM-YYYY HH:mm:ss';
    let dateLabel = '';
    if (moment(startDate).isSame(moment(endDate), 'days')) {
      dateLabel = allDay
        ? moment(formattedStart).format(format)
        : [
            moment(formattedStart).format(format),
            moment(formattedEnd).format('HH:mm:ss'),
          ].join(' - ');
    } else {
      dateLabel = [
        moment(formattedStart).format(format),
        moment(formattedEnd).format(format),
      ].join(' - ');
    }

    const filename = `Report Staff - ${dateLabel}`;
    const query = {
      start: formattedStart,
      end: getFormattedEndDate(formattedEnd),
      outletIds: outlet,
      filename,
    };
    clevertapReportsCollected.reportCollectedExport({
      outletIds: outlet,
      startDate: formattedStart,
      endDate: formattedEnd,
    });
    this.props.dispatch(exportCollectedBy(query, filename, outlet[0]));
  };
}

const selector = formValueSelector('search');

function select(state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
    },
    data: {
      reports: {
        staffs: state.reports.staffs,
      },
    },
  };
}

export default connect(select)(CollectedBy);
